import { Box, Typography, TableContainer, Table } from '@mui/material';

import DashboardBody from '../../../../shared/dashboardBody';
import DashboardHeader from '../../../../shared/dashboardHeader';

const Step1 = ({ selected, headers }) => {
    return (
        <Box>
            <Typography
                sx={(theme) => {
                    return {
                        mt: 'calc(10rem/16)',
                        mb: theme.spacing(2.5),
                    };
                }}
            >
                The{' '}
                <Box
                    sx={{ color: '#000000de' }}
                    component="b"
                >
                    {selected.length} invoices
                </Box>{' '}
                below have been selected for printing. Click{' '}
                <Box
                    component="b"
                    sx={{ color: (theme) => theme.palette.primary.main }}
                >
                    Continue to Step 2
                </Box>{' '}
                to name the PDF file.
            </Typography>
            <TableContainer
                sx={{
                    overflow: 'auto',
                }}
            >
                <Table
                    stickyHeader
                    size="small"
                >
                    <DashboardHeader headers={headers} />

                    <DashboardBody
                        headers={headers}
                        list={selected}
                        isFetching={false}
                        handleNav={() => null}
                    />
                </Table>
            </TableContainer>
        </Box>
    );
};

export default Step1;
